module.exports = __webpack_public_path__ + "static/img/device-5.e7a951f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/device-5.png
// module id = qB4Q
// module chunks = 0